import { CheckinProgressBar } from "./CheckinProgressBar";

interface CheckinHeaderProps {
  completedFields: number;
  totalRequiredFields: number;
}

export const CheckinHeader = ({ completedFields, totalRequiredFields }: CheckinHeaderProps) => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-heading font-bold text-foreground">Check-in diario</h1>
      <p className="text-sm text-foreground mt-1">¿Cómo te sientes hoy?</p>
      <p className="text-xs text-muted-foreground mt-1.5 flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-wellness-peach inline-block" />
        Esto toma menos de 1 minuto
      </p>
      <CheckinProgressBar completed={completedFields} total={totalRequiredFields} />
    </div>
  );
};
